<div class="page">
    <div class="list" *ngIf="!loading else loader">
        <app-activity *ngFor="let operation of ticket.ticketOperations"
                      [activity]="operation"
                      [canSelect]="canSelect(operation)"
                      [finished]="operation.status === 'Resolved'"
                      (click)="onSelectActivity($event)">
        </app-activity>
    </div>
</div>

<ng-template #loader>
    <div class="loader">
        <app-loading-spinner></app-loading-spinner>
    </div>
</ng-template>
